import { capitalize } from '@app/utils/string-helpers'

function setReportEditName(event: Event): void {
  event.preventDefault()
  event.stopPropagation()

  const pencilEditIcon = event.target as HTMLElement

  const templateName = document.querySelector(
    '[data-behaviour~="template-name"]'
  ) as HTMLInputElement

  const initialValue = templateName.textContent

  const languagePicker = document.querySelector(
    '[data-behaviour="report-current-language"]'
  ) as HTMLInputElement

  const h2 = pencilEditIcon.closest('h2')

  if (!h2 || !templateName || !languagePicker) {
    return
  }

  h2.classList.add('editable-editing')

  templateName.setAttribute('contenteditable', 'true')

  templateName.addEventListener(
    'focusout',
    function (event) {
      event.preventDefault()
      event.stopPropagation()

      const text = templateName.textContent

      if (text?.length === 0) {
        templateName.textContent = initialValue
      }

      if (text) {
        // we have to push the changed name to the correct data-name-xx
        // in index.js.coffee we fetch all the different language names
        // so it will be saved correctly in the controller
        templateName.dataset[`name${capitalize(languagePicker.value)}`] = text
      }

      h2.classList.remove('editable-editing')

      templateName.setAttribute('contenteditable', 'false')
    },
    { once: true }
  )
}

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const pencilEditIcon = doc.querySelector(
      '[data-behaviour="edit-template-name"]'
    ) as HTMLElement

    pencilEditIcon?.removeEventListener('click', setReportEditName)
    pencilEditIcon?.addEventListener('click', setReportEditName)
  })
}
